import { IBookmarkArticleDataResponse, ArticleData, BookMarkArticleTrackingData } from "../components/types";

export function mapArticleData(response: IBookmarkArticleDataResponse): ArticleData {
    return {
        productName: response.productName,
        colorName: response.colorName,
        sizeName: response.sizeName,
        modelName: response.modelName,
        imageUrl: response.imageUrl,
        savKey: response.savKey,
        categoryName: response.categoryName,
    };
}

export function mapBookmarkTrackingData(response: IBookmarkArticleDataResponse): BookMarkArticleTrackingData {
    return {
        navKeyPath: response.navKeyPath,
        grossPrice: response.grossPrice,
        currencyISOCode: response.currencyISOCode
    };
}